import React, { useState, useContext, useEffect, useRef } from 'react';
import { UserContext } from '../../contexts/userContext';
import request from '../../../services/Request';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../../dashboard/components/ModernTable';
import { useTheme } from '@mui/material/styles';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import Swal from 'sweetalert2';
import BrandPositionModal from './BrandPositionModal';
import { userLimits } from '../../dashboard/uitls/userLimits';
import { useHistory } from 'react-router-dom';
import { Typography, Box, Stack } from '@mui/material';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const getAllBrandURL = `/machines/getFilteredBrand/`;
const addBrandToMachineURL = `/machines/updateBrand`;
const getMachineURL = `/machines/edit/`;

export default function AddBrandToMachine(props) {
  const theme = useTheme();
  const { filterd } = useContext(UserContext);
  const history = useHistory();
  const { id, access } = userLimits(
    props.match.params.id,
    props.match.params.group,
    '',
    'edit_machine'
  );

  const machineID = props.match.params.id !== 'all' ? props.match.params.id : null;
  const theme1 = JSON.parse(localStorage.getItem('user'))?.theme === '1';

  const [allBrands, setAllBrands] = useState([]);
  const [loading, setLoading] = useState(false);
  const [machine, setMachine] = useState(null);
  const [reflesh, setReflesh] = useState(false);
  const [title, setTitle] = useState('');
  const [show, setShow] = useState(false);
  const [b_row, setB_row] = useState(null);
  const [checkBrand, setCheckBrand] = useState([]);
  const tableRef = useRef(null);

  useEffect(() => {
    // 检查 filterd 是否存在且不为空，如果为空则重定向到 viewMyMachines
    if (!machineID && (!filterd || filterd.length === 0)) {
      console.log('No machines selected, redirecting to viewMyMachines');
      history.push('/dashboard/viewMyMachines');
      return;
    }

    let machineURL1 = machineID ? machineID : filterd[0]._id;

    if (machineID) {
      const getMachine = async () => {
        await request({
          method: 'get',
          url: getMachineURL + machineURL1,
        }).then((res) => {
          setMachine(res.data);
          if (res.data.themeColor?.b_row) {
            setB_row(res.data.themeColor?.b_row);
          }
          // console.log(res.data);
        });
      };
      getMachine();
    } else {
      let string = '';
      if (filterd && filterd.length > 0) {
        filterd.forEach((e) => {
          string += e.name + ', ';
        });
        string = string.substring(0, string.length - 2);
      }
      setTitle(string);
    }

    const getBrands = async () => {
      await request({
        method: 'get',
        url: getAllBrandURL + machineURL1,
      }).then((res) => {
        let brand0 = res.data[0];
        let brand1 = res.data[1];

        brand0.forEach((e) => {
          e.name = e.name?.en;
        });

        brand1.forEach((e) => {
          e.name = e.name?.en;
        });
        const checkedCate = res.data[0];
        checkedCate.forEach((e) => (e.tableData = { checked: true }));
        const cate = checkedCate.concat(res.data[1]);
        setAllBrands(cate);
        setLoading(true);
      });
    };
    getBrands();

    return () => {
      setAllBrands([]);
      setMachine(null);
      setB_row(null);
    };
  }, [reflesh]);

  const handleSubmit = async () => {
    const cateIDs = checkBrand.length !== undefined ? checkBrand.map((cate) => cate._id) : [];
    await request({
      method: 'post',
      url: addBrandToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : (filterd?.map((e) => e._id) || []),
        ids: cateIDs,
        b_row: b_row,
      },
    }).then((res) => {
      setShow(false);
      Swal.fire({
        text: `The Brand has been successfully updated`,
        icon: 'success',
        target: document.getElementById('swal2-container'),
      });
      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const addBrand = async (data) => {
    const cateIDs = data.length !== undefined ? data.map((cate) => cate._id) : [];
    data.forEach((element, i) => {
      element.id = i + 1;
    });
    setCheckBrand(data);
    await request({
      method: 'post',
      url: addBrandToMachineURL,
      data: {
        machineID: machineID ? new Array(machineID) : (filterd?.map((e) => e._id) || []),
        ids: cateIDs,
        b_row: b_row,
      },
    }).then((res) => {
      if (!theme1) {
        Swal.fire({
          text: `The Brand has been successfully updated`,
          icon: 'success',
          target: document.getElementById('swal2-container'),
        });
      } else {
        Swal.fire({
          text: `The Brand has been successfully updated, Please arrange your brand position`,
          icon: 'success',
          target: document.getElementById('swal2-container'),
        }).then((e) => {
          setShow(true);
        });
      }

      reflesh ? setReflesh(false) : setReflesh(true);
    });
  };

  const columns = [
    {
      title: 'Picture',
      field: 'picture',
      editable: 'never',
      cellStyle: {
        textAlign: 'left',
      },
      headerStyle: {
        textAlign: 'left',
      },
      render: (rowData) => (
        <img
          src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.picture}/${id}`}
          style={{
            width: 200,
            borderRadius: theme.shape.borderRadius,
            boxShadow: theme.shadows[2],
          }}
          alt={rowData.name}
        />
      ),
    },
    {
      title: 'Logo',
      field: 'logo',
      cellStyle: {
        textAlign: 'left',
      },
      headerStyle: {
        textAlign: 'left',
      },
      render: (rowData) =>
        rowData.logo ? (
          <img
            src={`${process.env.REACT_APP_SERVER_API}/pictures/${rowData.logo}/${id}`}
            style={{
              maxWidth: 200,
              borderRadius: theme.shape.borderRadius,
              boxShadow: theme.shadows[2],
            }}
            alt={`${rowData.name} logo`}
          />
        ) : (
          <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
            No image
          </Typography>
        ),
    },
    {
      title: 'Brand Name',
      field: 'name',
      cellStyle: {
        textAlign: 'left',
      },
      headerStyle: {
        textAlign: 'left',
      },
      render: (rowData) => (
        <Stack direction="row" spacing={1} alignItems="center">
          <LocalOfferIcon sx={{ fontSize: 20, color: theme.palette.primary.main }} />
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {rowData.name}
          </Typography>
        </Stack>
      ),
    },
    {
      title: '',
      field: '',
      cellStyle: {
        width: '1px',
        padding: 0,
      },
      headerStyle: {
        width: '1px',
        padding: 0,
      },
      render: () => null,
    },
  ];

  // 如果没有机器ID且 filterd 为空，显示加载状态（等待重定向）
  if (!machineID && (!filterd || filterd.length === 0)) {
    return <LoadingIcon />;
  }

  return (
    <ModernPageContainer>
      <BrandPositionModal
        machine={machine}
        b_row={b_row}
        setB_row={setB_row}
        show={show}
        brand={checkBrand}
        setBrand={setCheckBrand}
        onHide={() => setShow(false)}
        handleSubmit={handleSubmit}
      />
      <ModernPageHeader
        title="Update Brands"
        subtitle={
          machine
            ? `For Machine: ${machine.name}`
            : `For Machines: ${title}`
        }
        icon={LocalOfferIcon}
        buttons={[
          access && {
            text: 'Save Changes',
            icon: SaveIcon,
            onClick: () => {
              const selectedRows = tableRef.current?.dataManager?.data?.filter(row => row.tableData?.checked) || [];
              console.log('selectedRows from tableRef', selectedRows);
              addBrand(selectedRows);
            },
            variant: 'contained',
          },
          {
            text: 'Go Back',
            icon: ArrowBackIcon,
            onClick: () => history.goBack(),
            variant: 'outlined',
          },
        ].filter(Boolean)}
      />

      {!loading ? (
        <LoadingIcon />
      ) : (
        <Box sx={{ width: '100%' }}>
          <ModernTable
            tableRef={tableRef}
            columns={columns}
            data={allBrands}
            title="Add Brands To the Machine"
            options={{
              actionsColumnIndex: -1,
              selection: true,
              pageSize: 10,
              pageSizeOptions: [5, 10, 20, 50],
              headerStyle: {
                textAlign: 'left',
              },
              cellStyle: {
                textAlign: 'left',
              },
            }}
          />
        </Box>
      )}
    </ModernPageContainer>
  );
}
